import {ThreeUnit} from '../../../ThreeUnit/ThreeUnit';
import {KitchenService} from '../../../../../services/KitchenService/KitchenService';
import {Vector3} from 'three';
import {TDetail} from '../../../../../types/TDetail';
import {
    OPTION_TYPE_CHECKBOX,
    SIDE_TYPE_BACK,
    SIDE_TYPE_BOTTOM, SIDE_TYPE_LEFT,
    SIDE_TYPE_NONE, SIDE_TYPE_RIGHT,
} from '../../../../../../../common-code/constants';
import {ICoverPoints} from '../../../../../interfaces/ICoverPoints';
import {ThreeAccessoryUnit} from '../ThreeAccessoryUnit';
import {ISaveTabletopUnitData} from '../../../../../../../common-code/interfaces/saveData/ISaveTabletopUnitData';
import {ITabletopData} from '../../../../../../../common-code/interfaces/materials/ITabletopData';
import {ISaveKUnitDetailData} from '../../../../../../../common-code/interfaces/saveData/ISaveKUnitDetailData';
import {ISaveUnitData} from '../../../../../../../common-code/interfaces/saveData/ISaveUnitData';
import {ISettingGroup} from '../../../../../../interfaces/settingData/ISettingGroup';
import {ISettingGroupGeneral} from '../../../../../../interfaces/settingData/ISettingGroupGeneral';
import {SETTING_GROUP_GENERAL} from '../../../../../../constants';
import {i18n} from '../../../../../../i18n';
import {IOptionCheckbox} from '../../../../../../../../../common/interfaces/option/IOptionCheckbox';

export class ThreeTabletopUnit extends ThreeAccessoryUnit {
    saveData: ISaveTabletopUnitData;

    constructor(options: ISaveTabletopUnitData, service: KitchenService) {
        super(options, service);
        this.saveData = this.initSaveData(options);
    }

    public initState(isRebuild?: boolean) {
        this.addCoverPoints([
            new Vector3(-this.getWidth()/2, -this.getHeight()/2, -this.getDepth()/2),
            new Vector3(this.getWidth()/2, this.getHeight()/2, this.getDepth()/2)
        ]);
        super.initState(isRebuild);
    }

    public getUnionDetailYPosition(detail: TDetail): number {
        return this.view3d.position.y;
    }

    public defaultYPosition(): number {
        return this.service.getBottomUnitLegsHeight() + this.service.getBottomUnitHeight() + this.getSideDistance(SIDE_TYPE_BOTTOM);
    }

    public getAvailableHeights(): number[] | undefined {
        let availableHeights: number[] = [];
        let tabletopMaterial: ITabletopData | undefined;

        if (this.tabletops && this.tabletops[0]) {
            tabletopMaterial = this.tabletops[0].getMaterialData();
        }
        if (tabletopMaterial && tabletopMaterial.heights) {
            availableHeights = tabletopMaterial.heights;
        }

        return availableHeights.length ? availableHeights : undefined;
    }

    public getSettingsGroups(): {[key: string]: ISettingGroup} {
        let groups: {[key: string]: ISettingGroup};
        let generalGroup: ISettingGroup | undefined;
        let generalGroupData: ISettingGroupGeneral | undefined;

        groups = super.getSettingsGroups();
        generalGroup = groups[SETTING_GROUP_GENERAL];
        if (generalGroup && generalGroup.data) {
            generalGroupData = generalGroup.data as ISettingGroupGeneral;
        }
        if (generalGroupData) {
            generalGroupData.other.push({
                id: 'hasCorner',
                sort: 0,
                title: i18n.t('Строить пристеночный плинтус'),
                type: OPTION_TYPE_CHECKBOX,
                value: !!this.saveData.hasCorner,
                defaultValue: !!this.saveData.hasCorner,
                changeOnBlur: true
            } as IOptionCheckbox);
            // generalGroupData.other.push({
            //     id: 'isFlipX',
            //     defaultValue: this.isFlipX(),
            //     type: OPTION_TYPE_CHECKBOX,
            //     title: i18n.t('Отобразить по горизонтали'),
            //     sort: 1,
            // } as IOptionCheckbox);
            // generalGroupData.other.push({
            //     id: 'isFlipY',
            //     defaultValue: this.isFlipY(),
            //     type: OPTION_TYPE_CHECKBOX,
            //     title: i18n.t('Отобразить по вертикали'),
            //     sort: 1,
            // } as IOptionCheckbox);
        }

        return groups;
    }

    protected correctSizesByTabletop(saveData: ISaveUnitData) {
        let tabletopHeight: number | undefined;
        let tabletopData: ISaveKUnitDetailData;
        if (!saveData.tabletops) {
            return;
        }
        for (tabletopData of saveData.tabletops) {
            if (tabletopData.sizes !== undefined &&
                tabletopData.sizes.height !== undefined &&
                !isNaN(+tabletopData.sizes.height)) {
                tabletopHeight = +tabletopData.sizes.height;
                break;
            }
        }
        if (tabletopHeight !== undefined && !isNaN(+tabletopHeight)) {
            saveData.sizes.height = +tabletopHeight;
        }
    }

    protected initSaveData(options: ISaveTabletopUnitData): ISaveTabletopUnitData{
        super.initSaveData(options);
        options.sizes.height = this.initHeight(options);

        return options;
    }

    protected initHeight(options: ISaveTabletopUnitData): number {
        let initHeight: number;
        let tabletop: ITabletopData | undefined;

        initHeight = options.sizes.height;
        try {
            if (options.tabletops && options.tabletops[0] && options.tabletops[0].material) {
                tabletop = this.service.getTabletopMaterial(options.tabletops[0].material);
            }
            if (tabletop) {
                initHeight = (tabletop.heights && tabletop.heights.includes(options.sizes.height)) ? options.sizes.height : tabletop.height;
            } else {
                if (!this.service.getTabletopHeights().includes(initHeight)) {
                    initHeight = this.service.getTabletopHeight();
                }
            }
        } catch (e) {
            initHeight = options.sizes.height;
        }

        return initHeight;
    }

    protected initCornersData(corners?: ISaveKUnitDetailData[]): ISaveKUnitDetailData[] | undefined {
        if (this.saveData.hasCorner) {
            if (corners && corners.length > 0) {
                return corners;
            }
            return [
                {
                    id: 0,
                    positionType: SIDE_TYPE_BACK,
                },
                {
                    id: 0,
                    positionType: SIDE_TYPE_LEFT,
                },
                {
                    id: 0,
                    positionType: SIDE_TYPE_RIGHT,
                }
            ];
        } else {
            return undefined;
        }
    }

    protected initTabletopsData(tabletops?: ISaveKUnitDetailData[]): ISaveKUnitDetailData[] | undefined {
        let tabletop: ISaveKUnitDetailData;

        if (!tabletops) {
            tabletops = [{
                id: 0,
                initPosition: {x: 0, y: 0, z: 0},
                positionType: SIDE_TYPE_NONE,
                isSelfVisible: true,
            }]
        }
        for (tabletop of tabletops) {
            tabletop.sizes = {
                height: this.getHeight(),
                width: this.getDepth(),
                length: this.getWidth()
            }
        }

        return tabletops;
    }

    protected getMoveLines(): number[] {
        let unitGlobalPoints: ICoverPoints;
        let lines: number[];
        let unit: ThreeUnit;

        lines = [];
        lines.push(this.service.getInstallBottomUnitHeight(true));
        lines.push(this.service.getInstallBottomUnitHeight());
        const tabletopUnits: ThreeUnit[] = this.service.getUnits(['tabletops']);
        for (unit of tabletopUnits) {
            if (this.getId() === unit.getId()) {
                continue;
            }
            unitGlobalPoints = unit.getGlobalPoints(unit.selectCover);
            lines.push(Math.round(unitGlobalPoints.box.min.y));
            lines.push(Math.round((unitGlobalPoints.box.min.y + unitGlobalPoints.box.max.y)/2));
            lines.push(Math.round(unitGlobalPoints.box.max.y));
        }

        lines = lines.filter((item, index) => {
            return lines.indexOf(item) === index;
        });

        return lines;
    }
}